export let defaultDuration = 60 * 1000;
export function setDefaultDuration(duration) {
    defaultDuration = duration;
}
export function getDefaultDuration() {
    return defaultDuration;
}
